import React from 'react';
import { observer } from 'mobx-react';

import { CollectionProgramAsset } from '@kaltura-ott/tvpil-shared';

import { Card, CardBubbleInfo, CardInner, CardTitle } from 'components/presenters';

import SeriesCatchUpCardContent from './components/SeriesCatchUpCardContent/SeriesCatchUpCardContent';
import { useSeriesCatchUpCard } from './hooks/useSeriesCatchUpCard/useSeriesCatchUpCard';

interface Props {
  seriesCatchup: CollectionProgramAsset;
  itemWidth: number;
  imageHeight: number;
}

function SeriesCatchUpCard({ seriesCatchup, itemWidth, imageHeight }: Props) {
  const {
    link,
    title,
    isAdult,
    isRecord,
    handleRef,
    ariaLabel,
    assetRating,
    channelName,
    clickHandler,
    onMouseEnter,
    onMouseLeave,
    isLinkAsAsset,
    handleLinkRef,
    isSeriesRecord,
    handleClickInfo,
    isDisplayRating,
    defaultImageUrl,
    channelHasProgram,
    backgroundImageUrl,
    seasonEpisodeTitle,
    shouldDisplayCartIcon,
  } = useSeriesCatchUpCard({ seriesCatchup, itemWidth, imageHeight });

  return (
    <Card
      handleLinkRef={handleLinkRef}
      clickHandler={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      link={link}
      imageHeight={imageHeight}
      itemWidth={itemWidth}
      isMosaicProgram={false}
      ariaLabel={ariaLabel}
    >
      <CardInner
        defaultImageUrl={defaultImageUrl}
        cardType='collection'
        url={backgroundImageUrl}
        name={title}
        handleRef={handleRef}
        handleLinkRef={handleLinkRef}
        isAdult={isAdult}
        isNoDataWithNoLogoImg={false}
        contentOverlay={
          <SeriesCatchUpCardContent
            shouldDisplayCartIcon={shouldDisplayCartIcon}
            shouldDisplayRating={isDisplayRating}
            assetRating={assetRating}
          />
        }
      />
      <CardBubbleInfo
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        channelHasProgram={channelHasProgram}
        seasonEpisodeTitle={seasonEpisodeTitle}
        channelName={channelName}
        isAdult={isAdult}
        title={title}
        isMosaicProgram={false}
        handleClickInfo={handleClickInfo}
        isLinkAsAsset={isLinkAsAsset}
      />
      <CardTitle
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        seasonEpisodeTitle={seasonEpisodeTitle}
        isAdult={isAdult}
        isStaticInfo
        title={title}
        isMosaicProgram={false}
      />
    </Card>
  );
}

export default observer(SeriesCatchUpCard);
